import { render, staticRenderFns } from "./Categorylist.vue?vue&type=template&id=8221e006&scoped=true&"
import script from "./Categorylist.vue?vue&type=script&lang=js&"
export * from "./Categorylist.vue?vue&type=script&lang=js&"
import style0 from "./Categorylist.vue?vue&type=style&index=0&id=8221e006&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8221e006",
  null
  
)

export default component.exports